// extracted by mini-css-extract-plugin
export default {"component":"Radio_component__wOpJc","checkedWrapper":"Radio_checkedWrapper__hSEM1","customRadio":"Radio_customRadio__sJ3OJ","label":"Radio_label__taE7s"};